import { render } from "./MaoFirstLanguage.vue?vue&type=template&id=09db73a5&scoped=true"
import script from "./MaoFirstLanguage.vue?vue&type=script&lang=js"
export * from "./MaoFirstLanguage.vue?vue&type=script&lang=js"

import "./MaoFirstLanguage.vue?vue&type=style&index=0&id=09db73a5&lang=scss"
import "./MaoFirstLanguage.vue?vue&type=style&index=1&id=09db73a5&scoped=true&lang=scss"
import "./MaoFirstLanguage.vue?vue&type=style&index=2&id=09db73a5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09db73a5"]])

export default __exports__